import {
  Elements,
  PaymentMethodMessagingElement,
} from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { env } from "@/env";

const stripe = loadStripe(env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY, {
  locale: "de",
});

export const ShowInstallments = ({ price }: { price?: number }) => {
  if (price === 0 || !price) {
    return null;
  }

  return (
    <Elements stripe={stripe}>
      <PaymentMethodMessagingElement
        options={{
          amount: price,
          currency: "EUR",
          countryCode: "DE",
          paymentMethodTypes: ["klarna"],
        }}
      />
    </Elements>
  );
};
